import {observer} from "mobx-react-lite";
import {useState} from 'react';
import {VirtuosoGrid} from 'react-virtuoso';
import {useAppEditorStore, useTransitionEnd} from '../../../app/store/appEditorStore';
import {includesSearch} from '../../../app/editor/utils';
import cx from '../../../app/editor/utils/makeCls';
import Button from '../Button';
import Grid from "../Grid";
import GridItem from '../GridItem';
import InputField from '../InputField';
import Popover from '../Popover';
import UploadField from '../UploadField';
import AssetCard from "./AssetCard";
import axios from "axios";
import {ImageUpdateStack, useUndoManager} from "../../../app/store/UndoManager";
import {findParent} from "../../../app/editor";
import {toast} from "react-toastify";

export default observer(function AssetManager({assets, select, close}) {
    const appEditorStore = useAppEditorStore();
    const undoManager = useUndoManager();
    const [tid] = useTransitionEnd();
    const [searchValue, setSearchValue] = useState('');
    const [urlValue, setUrlValue] = useState('');
    const [items, setItems] = useState(assets);
    const editor = appEditorStore.commonBoardEditorModal.state ? appEditorStore.commonEditor : appEditorStore.editor;
    const Assets = editor ? editor.Assets : undefined;
    let selectedSrc = null;
    try {
        selectedSrc = editor && editor.getSelected() ? editor.getSelected().attributes.attributes.src : null;
    } catch (e) {
        selectedSrc = null;
    }


    const filteredAssets = items.filter((asset) => {
        return !(searchValue &&
            !includesSearch(asset.getSrc(), searchValue) &&
            !includesSearch(asset.get('name'), searchValue));
    });

    const onRemove = (asset) => {
        setItems(assets.filter(a => a.getSrc() !== asset.getSrc()));
        Assets.remove(asset);
        appEditorStore.removeAsset(asset.getSrc())
    };
    const onSelect = (asset) => {
        const component = appEditorStore.commonBoardEditorModal.state ? appEditorStore.commonEditor.getSelected() : appEditorStore.editor.getSelected();
        select(asset);
        component.view.$el.addClass('on');
        if (selectedSrc !== asset.attributes.src) {
            const higherComponent = findParent(component);
            const connectedBoardId = higherComponent.attributes.attributes['data-id'];
            const {
                selectorType,
                selector,
                selectorIdx,
                parentSelector,
                parentIdx
            } = appEditorStore.getComponentSelector(component);
            undoManager.add(new ImageUpdateStack({
                connectedBoardId,
                selectorType, selector, selectorIdx, parentSelector, parentIdx,
                imageSrc: selectedSrc
            }, {
                connectedBoardId,
                selectorType, selector, selectorIdx, parentSelector, parentIdx,
                imageSrc: asset.attributes.src
            }));
        }
        close();
    }

    const handleUpload = async (ev) => {
        if (ev.target.files.length === 0) return;
        const fileMap = {}
        for (let i = 0; i < ev.target.files.length; i++) {
            const file = ev.target.files[i];
            fileMap[file.name] = file;
        }
        const response = await axios.get(`/image/uploadUrl?files=${JSON.stringify(Object.keys(fileMap))}`);
        const signedUrlMap = response.data.data.signedUrl;
        for (const fileName in signedUrlMap) {
            const splitFileNameList = fileName.split('.');
            const imageType = splitFileNameList[splitFileNameList.length - 1]
            await fetch(new Request(signedUrlMap[fileName], {
                method: 'PUT',
                body: fileMap[fileName],
                headers: {"Content-Type": `image/${imageType}`}
            })).then(() => {
                let url = signedUrlMap[fileName].split('?')[0];
                url = url.replace(import.meta.env.VITE_S3_URL, import.meta.env.VITE_CLOUDFRONT_URL);
                Assets.add(url);
                appEditorStore.pageInfo.assets.push(url);
            }).catch((err) => {
                console.log(err);
                toast('이미지 업로드에서 에러가 발생하였습니다.\n관라자에게 문의해주세요.')
            });

        }
        setItems(Assets.all.models);
    }

    const handleUrlAdd = (clb) => () => {
        if (urlValue) {
            Assets.add(urlValue);
            clb();
        }
    };

    return (
        <Grid col space="m">
            <Grid items="center" space="m">
                <GridItem className="mr-auto">
                    <InputField
                        size="s"
                        type="search"
                        value={searchValue}
                        onInput={setSearchValue}
                        placeholder={`Search...`}
                    />
                </GridItem>
                <GridItem>
                    <UploadField accept="image/*" onChange={handleUpload}/>
                </GridItem>
                <GridItem>
                    <Popover overlay title={false} buttonAs="span"
                             handler={<Button variant="pr" size="m2">{'Add URL'}</Button>}
                    >
                        {({close}) => (
                            <Grid space="m">
                                <GridItem>
                                    <InputField type="url" size="s" value={urlValue} onChange={setUrlValue}
                                                placeholder={'input url'}/>
                                </GridItem>
                                <GridItem>
                                    <Button variant="pr" size="m2"
                                            onClick={handleUrlAdd(close)}>{'Add'}</Button>
                                </GridItem>
                            </Grid>
                        )}
                    </Popover>
                </GridItem>
            </Grid>
            <Grid className={cx('h-[75vh]')} space="m" col nowrap>
                {
                    !filteredAssets.length ?
                        <Grid justify="center">{'No items foun'}</Grid>
                        :
                        <VirtuosoGrid
                            key={tid}
                            data={filteredAssets}
                            listClassName="grid grid-cols-4 gap-2 pr-2"
                            itemContent={(i, asset) => (
                                <AssetCard key={asset.getSrc()} asset={asset} onSelect={onSelect} onRemove={onRemove}/>
                            )}
                        />
                }
            </Grid>
        </Grid>
    );
});
